export function view(auth_user_id, message_user_id) {
  return message_user_id === auth_user_id ? 'Mine' : 'Theirs'
}
